import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  private sideBarVisibleSubject = new Subject<boolean>();
  public sideBarVisiblityChanged = this.sideBarVisibleSubject.asObservable();

  constructor() {
  }

  onMenuToggle() {
    this.sideBarVisibleSubject.next(true);
  }
}
